import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColumnAutomatisch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.672681,0,0,0.719677,4.187846,0.822883)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16.207,5.292L5.16,5.292C5.16,5.292 3.632,5.255 3.652,3.62C3.673,2.004 5.269,2.04 5.269,2.04L12.71,2.04",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.672681,0,0,0.719677,4.283698,17.900445)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.269,2.04L17.82,2.04C17.82,2.04 19.432,2.004 19.432,3.652C19.432,5.301 17.793,5.292 17.793,5.292L5.16,5.292C5.16,5.292 3.632,5.255 3.652,3.62C3.673,2.004 5.269,2.04 5.269,2.04Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.920185,0,0,0.934265,0.909853,-0.24461)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.002,5.219L14.875,5.219C14.875,5.219 13.885,5.173 13.904,7.414C13.922,9.655 13.904,19.018 13.904,19.018C13.904,19.018 13.958,20.967 15.944,20.985C17.929,21.003 8.02,20.985 8.02,20.985C8.02,20.985 10.042,21.003 10.024,19.036C10.005,17.069 10.024,7.596 10.024,7.596C10.024,7.596 10.169,5.173 8.002,5.219Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.62px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.885,3.33C21.004,3.599 21.214,3.818 21.482,3.937L22.617,4.445C22.956,4.604 22.956,5.082 22.617,5.242L21.492,5.75C21.223,5.869 21.004,6.089 20.895,6.357L20.009,8.438C19.85,8.767 19.372,8.767 19.212,8.438L18.326,6.357C18.207,6.088 17.997,5.869 17.729,5.75L16.604,5.242C16.265,5.083 16.265,4.605 16.604,4.445L17.729,3.937C17.998,3.818 18.217,3.598 18.326,3.33L19.212,1.249C19.371,0.92 19.849,0.92 20.009,1.249L20.885,3.33Z",
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.135,9.305C23.135,9.833 22.717,10.271 22.209,10.271C21.701,10.271 21.283,9.843 21.283,9.305C21.283,8.767 21.701,8.339 22.209,8.339C22.717,8.339 23.135,8.767 23.135,9.305Z",
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.09,2.922C15.608,2.922 16.016,2.494 16.016,1.956C16.016,1.418 15.608,1 15.09,1C14.572,1 14.164,1.428 14.164,1.966C14.164,2.504 14.582,2.932 15.09,2.932L15.09,2.922Z",
			style: { fill: "currentColor" }
		})
	]
});
export default SvgColumnAutomatisch;
